import { Component, Input, OnChanges, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Actualite } from '../../_interfaces/actualite';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'app-actualite-content',
    imports: [CommonModule],
    templateUrl: './actualite-content.component.html',
    styleUrls: ['./actualite-content.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    encapsulation: ViewEncapsulation.None
})
export class ActualiteContentComponent implements OnChanges {
  @Input() actualite?: Actualite;

  sanitizedContent?: SafeHtml;

  constructor(private sanitizer: DomSanitizer) {}

  private cleanContent(content: string): string {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = content;

    const walkNodes = (node: Node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        const newText = node.textContent
          ?.replace(/\s*-\s*/g, '-')
          .replace(/\s+/g, ' ')
          .trim();
        if (newText) {
          node.textContent = newText;
        }
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        node.childNodes.forEach(walkNodes);
      }
    };

    walkNodes(tempDiv);
    return tempDiv.innerHTML;
  }

  ngOnChanges() {
    this.sanitizedContent = this.actualite?.contenu
      ? this.sanitizer.bypassSecurityTrustHtml(this.cleanContent(this.actualite.contenu))
      : undefined;
  }
}
